import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
// Brand switcher oculto temporalmente (no renderizar)
// import BrandSwitcher from './BrandSwitcher';
import { whatsappLink, PHONE_NUMBER } from '../utils/contact';

const Header = () => {
    const { t, currentLang } = useLanguage();
    const location = useLocation();
    const [logoFilter, setLogoFilter] = useState('none');
    const [contactOpen, setContactOpen] = useState(false);

    const getLangPath = (path) => {
        return currentLang && currentLang !== 'es' ? `/${currentLang}${path}` : path;
    };

    const getContextMessage = () => {
        const path = location.pathname;
        if (
            path.includes('/studio') ||
            path.includes('/lab') ||
            path.includes('/renovation') ||
            path.includes('/reforma')
        ) {
            return t('contact.whatsapp.studio');
        }
        if (
            path.includes('/agency') ||
            path.includes('/sell') ||
            path.includes('/search') ||
            path.includes('/financing') ||
            path.includes('/community')
        ) {
            return t('contact.whatsapp.agency');
        }
        return t('contact.whatsapp.promotora');
    };

    const getContactPath = () => {
        const path = location.pathname;
        if (
            path.includes('/studio') ||
            path.includes('/lab') ||
            path.includes('/renovation') ||
            path.includes('/reforma')
        ) {
            return '/studio/contact';
        }
        if (
            path.includes('/agency') ||
            path.includes('/sell') ||
            path.includes('/search') ||
            path.includes('/financing') ||
            path.includes('/community')
        ) {
            return '/agency/contact';
        }
        return '/contact';
    };

    useEffect(() => {
        // Función para aplicar el filtro inmediatamente
        const applyLogoFilter = () => {
            const root = document.querySelector(':root');
            const isDark = root?.getAttribute('color-scheme') === 'dark';
            setLogoFilter(isDark ? 'brightness(0) invert(1)' : 'none');
        };

        // Aplicar inmediatamente
        applyLogoFilter();

        // Observer para cambios
        const observer = new MutationObserver(applyLogoFilter);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['color-scheme']
        });

        return () => observer.disconnect();
    }, []);

    return (
        <header id="header" className="mxd-header">
            <div className="mxd-header__logo loading__fade">
                <div className="mxd-logo">
                    <img
                        src="/img/logo.png"
                        alt={t('common.alt_texts.logo')}
                        style={{
                            width: '145px',
                            height: 'auto',
                            display: 'block',
                            maxWidth: '100%',
                            filter: logoFilter,
                            transition: 'filter 0.3s ease'
                        }}
                    />
                </div>
            </div>
            <div className="mxd-header__center loading__fade">
                {/* Brand switcher oculto temporalmente (no renderizar) */}
            </div>
            <div className="mxd-header__controls loading__fade">
                <button
                    id="color-switcher"
                    className="mxd-color-switcher"
                    type="button"
                    role="switch"
                    aria-label="light/dark mode"
                    aria-checked="true"
                >
                    <i className="ph-bold ph-moon-stars"></i>
                </button>
                {/* Desktop: página de contacto */}
                <Link
                    className="btn btn-anim btn-default btn-mobile-icon btn-outline slide-right-up d-none d-md-inline-flex"
                    to={getLangPath(getContactPath())}
                >
                    <span className="btn-caption">{t('navigation.contact')}</span>
                    <i className="ph-bold ph-arrow-up-right"></i>
                </Link>

                {/* Mobile: popup WhatsApp / teléfono */}
                <button
                    type="button"
                    className="btn btn-anim btn-default btn-mobile-icon btn-outline slide-right-up d-md-none"
                    onClick={() => setContactOpen(true)}
                    aria-label={t('navigation.contact')}
                >
                    <span className="btn-caption">{t('navigation.contact')}</span>
                    <i className="ph-bold ph-arrow-up-right"></i>
                </button>
            </div>

            {contactOpen && (
                <div className="contact-popup" onClick={() => setContactOpen(false)}>
                    <div className="contact-popup__card" onClick={(e) => e.stopPropagation()}>
                        <button
                            type="button"
                            className="contact-popup__close"
                            onClick={() => setContactOpen(false)}
                            aria-label="Cerrar"
                        >
                            <i className="ph-bold ph-x"></i>
                        </button>
                        <p className="contact-popup__title h4">{t('contactPage.popup_title')}</p>
                        <div className="contact-popup__actions d-flex flex-column gap-3">
                            <a
                                href={whatsappLink(getContextMessage())}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-anim btn-primary btn-large slide-right-up"
                            >
                                <span className="btn-caption">{t('contactPage.whatsapp_btn')}</span>
                                <i className="ph-bold ph-whatsapp-logo"></i>
                            </a>
                            <a
                                href={`tel:${PHONE_NUMBER}`}
                                className="btn btn-anim btn-outline btn-large slide-right-up"
                            >
                                <span className="btn-caption">{t('contactPage.call_btn')}</span>
                                <i className="ph-bold ph-phone-call"></i>
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
